/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Import_SubInputs */

const en_notify_import_sub = /** @type {(inputs: Notify_Import_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When a recipe was imported or the import failed`)
};

const de_notify_import_sub = /** @type {(inputs: Notify_Import_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ein Rezept importiert ist oder der Import scheitert`)
};

/**
* | output |
* | --- |
* | "When a recipe was imported or the import failed" |
*
* @param {Notify_Import_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_import_sub = /** @type {((inputs?: Notify_Import_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Import_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_import_sub(inputs)
	return en_notify_import_sub(inputs)
});